import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useAuth } from '../hooks/auth';
import { PREVIOUS_PATH } from '../services/constants';
import LocalStorage from '../services/storage';

const storage = new LocalStorage();

const CheckLoggedIn = ({ children }) => {
	const { user } = useAuth();
	const location = useLocation();

	const auth_method = useSelector(state => state.account.auth_method);

	const path = location.pathname.split('/').pop();

	if (path === 'login' && user && auth_method?.set_password) {
		const previous_path = storage.getItem(PREVIOUS_PATH);
		const new_path = previous_path === '/logout' ? '/' : previous_path;
		return <Navigate to={new_path || '/'} state={{ from: location }} replace />;
	}

	return <>{children}</>;
};

export default CheckLoggedIn;
